export default __webpack_public_path__ + "static/media/marketing.d6526c40.jpg";